import React from 'react';
import { Helmet } from 'react-helmet-async';
import JsonLd from './JsonLd';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://pfaandassociates.com';
const DEFAULT_IMAGE = `${SITE_URL}/images/company-logo.png`;
const PUBLIC_PATH = process.env.PUBLIC_URL || '';

/**
 * Reusable SEO head component for page-level metadata.
 * Renders title, meta description, canonical URL, Open Graph, Twitter tags, and optional JSON-LD.
 */
const SEOHead = ({
  title,
  description,
  image,
  path = '/',
  type = 'website',
  robots = 'index, follow',
  jsonLd
}) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const canonicalUrl = `${SITE_URL}${normalizedPath}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content={robots} />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="icon" type="image/png" sizes="32x32" href={`${PUBLIC_PATH}/favicon.png`} />
        <link rel="apple-touch-icon" sizes="180x180" href={`${PUBLIC_PATH}/apple-touch-icon.png`} />
        <link rel="shortcut icon" href={`${PUBLIC_PATH}/favicon.png`} type="image/png" />

        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:alt" content="PFA & Associates LLP" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content={type} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      {jsonLd ? <JsonLd data={jsonLd} /> : null}
    </>
  );
};

export default SEOHead;
